// Socket.IO Configuration
const socketConfig = {
  // Socket server URL based on environment
  url: import.meta.env.VITE_SOCKET_URL || "http://localhost:3001",

  // Socket.IO client options
  options: {
    // Authentication
    auth: {
      token: () => localStorage.getItem("token"), // Function to get fresh token
    },

    // Connection settings
    autoConnect: true,
    reconnection: true,
    reconnectionAttempts: 5,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
    maxReconnectionAttempts: 5,
    timeout: 20000,

    // Transport settings
    forceNew: false,
    multiplex: true,

    // Additional headers for ngrok compatibility
    extraHeaders: {
      "ngrok-skip-browser-warning": "true",
    },
  },

  // Event names constants
  events: {
    // Connection events
    CONNECT: "connect",
    DISCONNECT: "disconnect",
    CONNECT_ERROR: "connect_error",
    RECONNECT: "reconnect",
    RECONNECT_ERROR: "reconnect_error",

    // App-specific events (from backend)
    APP_UPDATE: "app-update",

    // App update types
    NEW_MESSAGE: "new-message",
    AI_RESPONSE: "ai-response",
    QR_CODE: "qr-code",
    WHATSAPP_CONNECTED: "whatsapp-connected",
    WHATSAPP_DISCONNECTED: "whatsapp-disconnected",
    SESSION_STATUS: "session-status",

    // Client events (to backend)
    SEND_MESSAGE: "send-message",
    JOIN_CONVERSATION: "join-conversation",
    LEAVE_CONVERSATION: "leave-conversation",
    TYPING_START: "typing-start",
    TYPING_STOP: "typing-stop",
  },

  // Environment-specific settings
  development: {
    debug: true,
    logLevel: "debug",
  },

  production: {
    debug: false,
    logLevel: "error",
  },
};

// Get environment-specific config
const getSocketConfig = () => {
  const isDevelopment = import.meta.env.DEV;
  const envConfig = isDevelopment
    ? socketConfig.development
    : socketConfig.production;

  return {
    ...socketConfig,
    ...envConfig,
  };
};

export default getSocketConfig();
export { socketConfig, getSocketConfig };
